/**
 * Accepts case-insensitive `true` / `false` / `yes` / `no`.
 * Returns a boolean when valid; otherwise `null` (caller skips).
 */
export const parseBoolValue = (raw: string): boolean | null => {
    const normalized = raw.trim().toLowerCase();

    if (normalized === 'true' || normalized === 'yes') {
        return true;
    }

    if (normalized === 'false' || normalized === 'no') {
        return false;
    }

    return null;
};
